import { render, staticRenderFns } from "./EditFileRequest.vue?vue&type=template&id=1f3c9ab0&"
import script from "./EditFileRequest.vue?vue&type=script&lang=js&"
export * from "./EditFileRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports